import {
  CrudMode,
  DataDisplay,
  Grid,
  pn,
  useElementBreakpoints,
  ValidationErrors
} from "@compass/core";
import { Input, Select } from "components";
import { EndReason, EndReasonEditResource, EndReasonViewResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";

export const EndReasonPageBody = (props: {
  crudMode: CrudMode;
  endReason: EndReason;
  setEndReason: (value: EndReason) => void;
  viewResource: EndReasonViewResource;
  editResource: EndReasonEditResource;
  validationErrors: ValidationErrors;
}) => {
  const { breakpointsRef, smallFieldBreakpoints } =
    useElementBreakpoints();
  const properties = props.viewResource.properties || [];

  const nameField = () => {
    const propertyName = pn<EndReason>("name");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.endReason.name}</DataDisplay>
    ) : (
      <Input
        
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.endReason.name}
        onChange={(e) =>
          props.setEndReason(
            produce(props.endReason, (draft) => {
              draft.name = e.target.value;
            })
          )
        }
      />
    );
  };

  const endReasonTypeField = () => {
    const propertyName = pn<EndReason>("endReasonTypeId");
    const property = properties.find((x) => x.propertyName === propertyName);

    return props.crudMode === "view" ? (
      <DataDisplay label={property?.displayName}>{props.endReason.endReasonType?.name}</DataDisplay>
    ) : (
      <Select
        modelProperty={property}
        errors={props.validationErrors[propertyName]}
        value={props.editResource.endReasonTypes?.find((x) => x.id === props.endReason.endReasonTypeId)}
        options={props.editResource.endReasonTypes}
        getOptionLabel={(option) => option.name}
        onChange={(e, value) =>
          props.setEndReason(
            produce(props.endReason, (draft) => {
              draft.endReasonTypeId = value?.id;
            })
          )
        }
      />
    );
  };

  return (
    <Grid ref={breakpointsRef} container spacing="sm">
      <Grid item xs={smallFieldBreakpoints}>
        {nameField()}
      </Grid>

      <Grid item xs={smallFieldBreakpoints}>
        {endReasonTypeField()}
      </Grid>
    </Grid>
  );
};
